import React from 'react'
import ReactDOM from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import { App } from './App'
import { initErrorReporter } from './data/errorReporter'
import './index.css'

// Wire global error capture before mounting React so errors thrown during
// the very first render still get a chance to ship to Firestore.
initErrorReporter()

// Force the service worker to activate and reload the tab the moment a
// new bundle is detected. Without this, vite-plugin-pwa's autoUpdate
// still leaves the current session stuck on the cached old shell — we
// kept shipping fixes and users reported the old UI because they were
// reading the service worker cache. Reloading once on update takes the
// decision out of the user's hands.
registerSW({
  immediate: true,
  onNeedRefresh() {
    window.location.reload()
  },
  onRegisteredSW(_url, registration) {
    if (!registration) return
    // Belt + braces: the spec only fires updatefound when the browser
    // actually checks for a new SW. Poll every 60s so a long-running
    // tab notices new deploys without the user having to refresh.
    setInterval(
      () => {
        registration.update().catch(() => {})
      },
      60 * 1000
    )
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
